'use client';

import { useEffect, useState } from 'react';
import type { KeyPrefix } from 'i18next';
import type { UseTranslationOptions } from 'react-i18next';
import { useTranslation as useReactTranslation } from 'react-i18next';
import isClient from '@/Util/globals';
import { useCurrentLanguage } from '@/Util/CurrentLanguageProvider';

export const nameSpaces: string[] = ['Checkout', 'login'];

export const useTranslation = (ns: string, options?: UseTranslationOptions<KeyPrefix<any>>) => {
  const translationReturn = useReactTranslation(ns, options);
  const { i18n } = translationReturn;
  const { resolvedLanguage } = i18n;
  const locale = useCurrentLanguage();
  const [activeLng, setActiveLng] = useState(locale);

  useEffect(() => {
    (async (): Promise<void> => {
      if (!nameSpaces.includes(ns)) {
        nameSpaces.push(ns);
      }
      if (!isClient() && !!locale && resolvedLanguage !== locale) {
        await i18n.changeLanguage(locale);
      } else {
        if (activeLng !== resolvedLanguage || activeLng !== locale) {
          setActiveLng(locale);
        }
        if ((!!locale || resolvedLanguage !== locale) && !!i18n?.changeLanguage) {
          await i18n.changeLanguage(locale);
        }
      }
    })();
  }, [locale, i18n, resolvedLanguage, activeLng, locale]);

  return translationReturn;
};
